$('.bubble, .scroller').on('click', function (e){
    e.preventDefault()
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#send-feedback").offset().top
    }, 1000);
})
$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

if(document.getElementById('send-feedback')){
    $(window).on('resize scroll', function() {
        if ($('#send-feedback').isInViewport()) {
            $('.bubble').fadeOut('fast')
        } else {
            $('.bubble').fadeIn('slow')
        }
    });
}
